var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow && _vm.list.length > 0)?_c('div',{staticClass:"history-dropdown"},[_vm._m(0),_c('div',_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"history-item",on:{"mousedown":function($event){return _vm.$emit('select', item)}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history-header"},[_c('span',[_vm._v("最近搜索历史")])])
}]

export { render, staticRenderFns }